'use strict'

export default class ColumnSet {
    constructor() {
        this.columns = {}
    }

    /** @param {TableColumn} tableColumn */
    put(tableColumn) {
        let name = tableColumn.getDisplayName();
        if (!this.columns[name])
            this.columns[name] = tableColumn;
    }

    /** @param {TableColumn[]} tableColumns */
    putAll(tableColumns) {
        for (const tableColumn of tableColumns) {
            this.put(tableColumn)
        }
    }

    /** @returns {TableColumn[]} */
    getSorted() {
        const result = [];
        for (const name in this.columns) {
            result.push(this.columns[name])
        }
        return result.sort((a, b) => {
            return a.getDisplayName().localeCompare(b.getDisplayName())
        })
    }
}